import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import * as Constants from './../models/Constants';
import { TbaBusinessLogicService } from './tba-business-logic.service';
import { AwsSqsService } from './aws-sqs.service';
@Injectable({
  providedIn: 'root'
})
export class LogoutBusinessLogicService {

  constructor(public rootScopeService: RootScopeService,
    private tbaService: TbaBusinessLogicService, public awsSQSService: AwsSqsService) { }



  userLogout() {
    
    this.rootScopeService.clearCache();
  }

  /**
   * 
   * @param self component for api service refrence 
   * validate customer account count and show a pop up model
   * 
   */
  validateLogOut(self) {
    if (this.rootScopeService.customerTabs.length > 1) {
      this.rootScopeService.openDialog({
        title: '',
        subheading: '',
        message: this.checkLiveInterMsg(),
        firstbutton: '',
        secondbutton: Constants.buttonEnum.gotIt,
        crossIcon: false,
        comingFrom: 'userprofile',
        additionalClass: 'logout-modal',
      });
    } else {
      this.appLogOut(self);
    }
  }

  /**
   * 
   * @param self for component refrence details
   * LogOut the application in client side and serve side 
   */
  appLogOut(self,timeout?) {
   /**Added below Try Catche for CCR1-7023 */
    try{
    this.rootScopeService.appTimeoutSuccess = true;
    this.rootScopeService.setTimeOutDetails({ 'watch': false, 'stop': true });
    this.rootScopeService.closeAllKcWindow();
    this.rootScopeService.closeAllExternalTabs();
    this.rootScopeService.closeALSTab();

    let linkMessageString = this.rootScopeService.linkTrackingMap?.get(Constants.DASHBOARD_LINK_TRACKING);
    /* istanbul ignore next */
    if (linkMessageString) {
      this.rootScopeService.linkTrackingMap?.delete(Constants.DASHBOARD_LINK_TRACKING);
      let logObj = this.rootScopeService.createAngluarLogsObject(linkMessageString, 'usage', 'N/A');
      this.awsSQSService.sendAngularLogsToSQS(logObj);
    }
    this.tbaService.closeTbaLogout();

    if (this.rootScopeService.customerTabs.find(x => x.id)) {
      this.sendLogsToSQS();
      /* istanbul ignore next */
      setTimeout(() => {
        self.apiService.appTimeOut();
      }, 1000);

    } else self.apiService.userLogout(timeout);

  } catch(error){
    self.apiService.appTimeOut();

  }



  }
  /**
   * @author VamsiKrishna
   * send telephone events logs to SQS
   * update wrap data in elastic caches 
   */
  sendLogsToSQS() {
    this.rootScopeService.customerTabs.forEach((x) => {
      if (x?.customerSessionId && x?.customerSessionId != '0' && x.conversationId != "NA") {
        let telephonyEventMessage = this.rootScopeService.liveInteractionLogs?.get(x?.conversationId);

        if (telephonyEventMessage) {
          this.rootScopeService.liveInteractionLogs?.delete(x?.conversationId);
          let livelogObj = this.rootScopeService.createAngluarLogsObject(telephonyEventMessage, "telephony", x);
          this.awsSQSService.sendAngularLogsToSQS(livelogObj);
        }

        /**
         * update wrap data in server side 
         */
        if (x.conversationId && x.conversationId != "NA" && !x.additionalAccount) {
          let payload = {
            'customerSessionId': x.customerSessionId,
            'cusTab': {
              'wrapUpData': x.wrapUpData,
              "interactionDisconnected": x.interactionDisconnected,
              'wrappedupCroosIcon': x.wrappedupCroosIcon
            }
          }
          this.rootScopeService.updateElasticData.next(payload);


        }
      }
    })

  }

  checkLiveInterMsg() {
    let message = Constants.user_logout_MSGOPENACCOUNT;

    switch (true) {
      case this.rootScopeService.isLiveCall:
        message = Constants.user_logout_MSGACTIVECALL
        break;
      case this.rootScopeService.isLiveChat:
        message = Constants.user_logout_MSGACTIVECHATS;
        break;
      default: message = Constants.user_logout_MSGOPENACCOUNT;
        break;
    }
    return message;
  }
}
